import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { RoleProvider, useRole, ROLES } from "@/context/RoleContext";
import { ThemeProvider } from "@/context/ThemeContext";
import { AppHeader } from "@/components/AppHeader";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import TravelerSubmit from "@/pages/TravelerSubmit";
import TravelerStatus from "@/pages/TravelerStatus";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminRecords from "@/pages/AdminRecords";
import AdminDetail from "@/pages/AdminDetail";
import AdminReports from "@/pages/AdminReports";

function ProtectedRoute({ allowedRole, children }) {
  const { role } = useRole();
  if (!role) return <Navigate to="/" replace />;
  if (allowedRole && role !== allowedRole) return <Navigate to="/" replace />;
  return children;
}

function Shell({ children }) {
  const location = useLocation();
  const showHeader = location.pathname !== "/";
  return (
    <div className="min-h-screen">
      {showHeader && <AppHeader />}
      {children}
    </div>
  );
}

function AppRoutes() {
  return (
    <Shell>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/traveler/submit" element={
          <ProtectedRoute allowedRole={ROLES.TRAVELER}><TravelerSubmit /></ProtectedRoute>
        } />
        <Route path="/traveler/status" element={
          <ProtectedRoute allowedRole={ROLES.TRAVELER}><TravelerStatus /></ProtectedRoute>
        } />
        <Route path="/admin" element={
          <ProtectedRoute allowedRole={ROLES.ADMIN}><AdminDashboard /></ProtectedRoute>
        } />
        <Route path="/admin/records" element={
          <ProtectedRoute allowedRole={ROLES.ADMIN}><AdminRecords /></ProtectedRoute>
        } />
        <Route path="/admin/records/:id" element={
          <ProtectedRoute allowedRole={ROLES.ADMIN}><AdminDetail /></ProtectedRoute>
        } />
        <Route path="/admin/reports" element={
          <ProtectedRoute allowedRole={ROLES.ADMIN}><AdminReports /></ProtectedRoute>
        } />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Shell>
  );
}

function App() {
  return (
    <ThemeProvider>
      <RoleProvider>
        <BrowserRouter>
          <AppRoutes />
          <Toaster position="top-right" theme="dark" />
        </BrowserRouter>
      </RoleProvider>
    </ThemeProvider>
  );
}

export default App;
